import React, { useContext } from "react";
import { AuthContext } from "../../context/authContext/authContext";
import { ProgramarViajesManuales } from "./ProgramarViajesManuales";
import { ProgramarViajesAutomaticos } from "./ProgramarViajesAutomaticos";


export const ProgramarRuta = () => {

  const { user } = useContext(AuthContext);
  
  return (
    <>
      {
        user && user.flujo_id === 1 ?
          <ProgramarViajesManuales busqueda={1}/>
        : user.flujo_id === 2 ?
          <ProgramarViajesAutomaticos/>
        : ""
      }
    </>
  );
};
